export default {"src":"/_next/static/media/PW_Header.f8c44295.svg","height":397,"width":1026,"blurWidth":0,"blurHeight":0};